import { Controller } from "@hotwired/stimulus";

// Group-toggle behavior for step2's shared "Bagagealternativ" section --
// same panel markup and same Hela/Ingen resesällskapet logic as step1's
// "Visa resa" overlay (itinerary_detail_controller.js), just under its own
// controller identifier (see _step_1_baggage_panel.html.erb's `controller`
// local) since this page also needs to trigger step2-price#recalculate
// afterward, which itinerary-detail knows nothing about -- chained directly
// in the checkbox's own data-action instead of duplicated here.
export default class extends Controller {
  static targets = ["baggagePanel", "optionGroup", "groupCheckbox", "realCheckbox"];

  connect() {
    // Options can already be pre-selected server-side (from step1's "Visa
    // resa" baggage choice, same real ancillary data) -- sync Hela/Ingen's
    // initial checked state to match rather than leaving both unchecked.
    this.baggagePanelTargets.forEach((panel) => this.syncGroupToggles(panel));
  }

  togglePanel(event) {
    const panel = event.currentTarget.closest('[data-step2-baggage-target="baggagePanel"]');
    const body = panel.querySelector('[data-step2-baggage-target="panelBody"]');
    const chevron = panel.querySelector('[data-step2-baggage-target="panelChevron"]');
    body.classList.toggle("hidden");
    chevron.classList.toggle("rotate-180");
  }

  toggleOption(event) {
    const panel = event.currentTarget.closest('[data-step2-baggage-target="baggagePanel"]');
    const group = event.currentTarget.closest('[data-step2-baggage-target="optionGroup"]');
    const checked = event.currentTarget.checked;
    group.querySelectorAll('[data-step2-baggage-target="realCheckbox"]').forEach((cb) => {
      cb.checked = checked;
    });
    this.syncGroupToggles(panel);
  }

  toggleAllInPanel(event) {
    const panel = event.currentTarget.closest('[data-step2-baggage-target="baggagePanel"]');
    const checked = event.currentTarget.checked;
    panel.querySelectorAll('[data-step2-baggage-target="groupCheckbox"]').forEach((cb) => {
      cb.checked = checked;
    });
    panel.querySelectorAll('[data-step2-baggage-target="realCheckbox"]').forEach((cb) => {
      cb.checked = checked;
    });
    this.syncGroupToggles(panel);
  }

  toggleNoneInPanel(event) {
    const panel = event.currentTarget.closest('[data-step2-baggage-target="baggagePanel"]');
    if (event.currentTarget.checked) {
      panel.querySelectorAll('[data-step2-baggage-target="groupCheckbox"]').forEach((cb) => {
        cb.checked = false;
      });
      panel.querySelectorAll('[data-step2-baggage-target="realCheckbox"]').forEach((cb) => {
        cb.checked = false;
      });
    }
    this.syncGroupToggles(panel);
  }

  syncGroupToggles(panel) {
    const groupCheckboxes = Array.from(panel.querySelectorAll('[data-step2-baggage-target="groupCheckbox"]'));
    if (groupCheckboxes.length === 0) return;
    const allChecked = groupCheckboxes.every((cb) => cb.checked);
    const noneChecked = groupCheckboxes.every((cb) => !cb.checked);

    const allCheckbox = panel.querySelector('[data-step2-baggage-target="allCheckbox"]');
    const noneCheckbox = panel.querySelector('[data-step2-baggage-target="noneCheckbox"]');
    if (allCheckbox) allCheckbox.checked = allChecked;
    if (noneCheckbox) noneCheckbox.checked = noneChecked;
  }
}
